import * as mutation_types from "./mutation_types";

export default {
    // [mutation_typNFO](state, payload) {
    //     state.learningInfo = [...payload]
    // },
    [mutation_types.M_SET_IS_BOOKING_NO_REGISTRATION](state, payload) {
        state.IsBookingNoRegistration = payload
    },
    [mutation_types.M_SET_IS_SETTINGS_NO_REGISTRATION](state, payload) {
        state.isSettingsNoRegistration = payload
    }
};
